import { useEffect, useState, useCallback, useMemo } from 'react';
import { isClient } from '../components/utilities/functions';

export const useExitIntent = (isReady = true, callback) => {
	const [isExiting, setIsExiting] = useState(false);

	const isMobile = useMemo(() => {
		if (!isClient) return;
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}, []);

	const handleMouseMove = useCallback((event) => {
		if (event.clientY <= 0) {
			setIsExiting(true);
		}
	}, []);

	const handleMouseLeave = useCallback(() => {
		setIsExiting(true);
	}, []);

	const handlePopState = useCallback(() => {
		setIsExiting(true);
	}, []);

	const handleMobileScroll = useCallback(() => {
		let lastScroll = 0;

		return () => {
			const currentScroll = window.scrollY;
			if (currentScroll < lastScroll && currentScroll < 100 && lastScroll > 100) {
				setIsExiting(true);
			}
			lastScroll = currentScroll;
		};
	}, []);

	useEffect(() => {
		if (!isReady) return;

		const onScroll = handleMobileScroll();

		if (isMobile) {
			window.addEventListener('popstate', handlePopState);
			window.addEventListener('scroll', onScroll);
		}

		document.addEventListener('mousemove', handleMouseMove);
		document.documentElement.addEventListener('mouseleave', handleMouseLeave);

		return () => {
			document.removeEventListener('mousemove', handleMouseMove);
			document.documentElement.removeEventListener('mouseleave', handleMouseLeave);

			if (isMobile) {
				window.removeEventListener('popstate', handlePopState);
				window.removeEventListener('scroll', onScroll);
			}
		};
	}, [isReady, isMobile, handleMouseMove, handleMouseLeave, handlePopState, handleMobileScroll]);

	useEffect(() => {
		if (isExiting && typeof callback === 'function') callback();
	}, [isExiting, callback]);

	return isExiting;
};
